import { render, staticRenderFns } from "./modalDocumentAttachment.vue?vue&type=template&id=a7194664&"
import script from "./modalDocumentAttachment.vue?vue&type=script&lang=js&"
export * from "./modalDocumentAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports